import React from "react";
import "./App.css";
import APPRoutes from "./app-routes";
import { GlobalStateProvider } from "./context/GlobalStateContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <GlobalStateProvider>
      <APPRoutes />
      {/* one toast container for the whole app, so messages survive page changes */}
      <ToastContainer
        position="top-right"
        newestOnTop
        closeOnClick
        pauseOnHover
        hideProgressBar
        theme="light"
        style={{ top: 92 }}
      />
    </GlobalStateProvider>
  );
}

export default App;
